<template>
  <div class="bradgall">
    <div class="flex gap-6 mt-8">
      <div class="w-1/2"><PieChart /></div>
      <div class="w-1/2"><BarChart /></div>
    </div>
  </div>
</template>


<script>
import PieChart from "./PieChart.vue";
import BarChart from "./BarChart.vue";

export default {
  components: {
    PieChart,

    BarChart,
  },
};
</script>

<style>
</style>